import {
  DataExportReq,
  DataExportRes,
  FaceRecognitionDataExportReq
} from '@gateway.Simulation'
import { yamadumiApi } from '../yamadumi-api'

export class FaceRecognitionDataExportGateway {
  static postDataExport = async (
    params: DataExportReq,
    mode: number
  ) => {
    const req: FaceRecognitionDataExportReq = {
      searchCondition: {
        ...params.searchCondition,
        totalCostFrom: params.searchCondition.totalCostFrom !== null ? params.searchCondition.totalCostFrom * 1000000 : params.searchCondition.totalCostFrom,
        totalCostTo: params.searchCondition.totalCostTo !== null ? params.searchCondition.totalCostTo * 1000000 : params.searchCondition.totalCostTo
      },
      generalPurposeSearchList: [],
      outputItemList: [],
      displayStartYear: '',
      mode
    }
    return await yamadumiApi.post<DataExportRes>(
      '/api/report/face-recognition-data-export', { data: req }
    )
  }
}
